import { NgModule } from '@angular/core';

import { CustomerRoutingModule } from './customer-routing.module';

@NgModule({
    imports: [
       CustomerRoutingModule
    ],
    declarations: [
    ]
  })
  export class CustomerModule { }
